export default __webpack_public_path__ + "static/about-3-3d18113b504973dc16629ba1a6373f83.jpg";